/**
 * Tiny pub/sub used by the global ⌘⇧F shortcut to toggle the focused panel's
 * maximize state.
 *
 * `PanelShell` owns the local `maximized` flag (it controls the surface
 * presentation), so the global hook just dispatches a signal carrying the
 * panel id. Each PanelShell subscribes; the matching id flips its state.
 */

type Listener = (panelId: string) => void;

const listeners = new Set<Listener>();

export const panelMaximizeBus = {
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => {
      listeners.delete(listener);
    };
  },
  dispatch(panelId: string): void {
    for (const listener of listeners) listener(panelId);
  },
};
